export default {
  SEARCH_CATALOG_KUSPIT_INVESTMENT_QUERY: Symbol.for('SEARCH_CATALOG_KUSPIT_INVESTMENT_QUERY'),
  CATALOG_KUSPIT_INVESTMENT_REPOSITORY: Symbol.for('CATALOG_KUSPIT_INVESTMENT_REPOSITORY'),
  CATALOG_KUSPIT_INVESTMENT_STATE_MANAGER: Symbol.for('CATALOG_KUSPIT_INVESTMENT_STATE_MANAGER'),
};
